import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Colores de la categoría de precio del barco según el diseño.
const BOAT_CATEGORIES: Record<string, { label: string; background: string; color: string }> = {
  premium: { label: 'Premium', background: '#333333', color: '#ffffff' },
  standard: { label: 'Standard', background: '#5bca90', color: '#000000' },
  luxury: { label: 'Luxury', background: '#fcc43c', color: '#000000' },
};

@Component({
  selector: 'usb-boat-result',
  templateUrl: './boat-result.component.html',
  styleUrls: ['../../../base-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoatResultComponent {

  @Input() result: any;

  get boat(): any {
    return this.result?.additionalInfo?.boat;
  }

  get category(): { label: string; background: string; color: string } | null {
    return BOAT_CATEGORIES[(this.boat?.category || '').toLowerCase()] || null;
  }

  get skipperIncluded(): boolean {
    return !!this.result?.additionalInfo?.skipper?.included;
  }
}
